// extracted by mini-css-extract-plugin
export default {"FooterLink":"FooterLink_FooterLink__BECz9","FooterLink__heading":"FooterLink_FooterLink__heading__Bm+03","FooterLink__links":"FooterLink_FooterLink__links__PcLBe"};